/* @flow */
import * as React from 'react';

type Props = {
  title: string,
  children?: React.Node,
};

// Tab component isn't meant to be rendered direactly
export function Tab(_props: Props) {
  return <div />;
}
